type Props = {
  size?: number;
};

export default function CriteriaFailedIcon({ size = 32 }: Props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} fill='none' viewBox='0 0 32 32'>
      <g strokeWidth='1.333'>
        <path
          stroke='#7c39ed'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M6 11.333h12.667M6 15.333h12.667M6 7.333h9.333M6 19.333h9.333M6 23.333h6M11.334 31.333H2A1.334 1.334 0 0 1 .667 30V2A1.333 1.333 0 0 1 2 .667h17.724c.354 0 .693.14.943.39L25.61 6c.25.25.39.59.39.943v4.39'
        />
        <path
          stroke='#d93f4c'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M23.333 24.667v-4M24.45 16.667a1.266 1.266 0 0 0-2.234 0l-6.741 12.846a1.23 1.23 0 0 0 .501 1.657c.189.105.4.16.616.16h13.483a1.26 1.26 0 0 0 1.076-.598 1.23 1.23 0 0 0 .041-1.219z'
        />
        <path stroke='#d93f4c' d='M23.333 28a.333.333 0 1 1 0-.667M23.333 28a.333.333 0 1 0 0-.667' />
      </g>
    </svg>
  );
}
